import React, { useEffect } from 'react';
import { Col, Container, Row, Button, } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion'
import Section from '../../Utilitis/Section';
import SingalHeader from '../../Utilitis/SingalHeader';
import Tag from '../../Utilitis/Tag';
import Teacher from '../../Utilitis/Teacher/Teacher';
import CourseComment from './Component.js/CourseComment';
import { motion } from 'framer-motion';
import { SinglCourseImage, EncrollBtn, SinglCourseInfo, InfoItem, CoursDetails, Icons, CoursInfoItem, Statistique, AuthorInfo, CoursDiscription, AcroodinHeader, TeacherCourse, MayCard } from './Style';
import ScrollAnimation from 'react-animate-on-scroll';

export default function SingleCourse() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <motion.div
                initial={{ y: "-100%" }}
                animate={{ y: 0 }}
                exit={{ y: "100%" }}
                transition={{ duration: 0.3 }}
            >
                <SingalHeader title="Single Course" id="header" />
                <Section bg="white" >
                    <Container>
                        <Row>
                            <Col lg={7} md={12} sm={12} xs={12}>
                                <ScrollAnimation animateIn="animate__fadeInLeft">
                                    <SinglCourseImage>
                                        <img src={"/images/bg.jpg"} />
                                    </SinglCourseImage>
                                    <CoursDetails>
                                        <h5>Data Product Manager</h5>
                                        <Icons>
                                            <Statistique>
                                                <CoursInfoItem>
                                                    <i className="fas fa-user"></i> <span>20</span>
                                                </CoursInfoItem>
                                                <CoursInfoItem>
                                                    <i className="fas fa-user"></i> <span>20</span>
                                                </CoursInfoItem>
                                            </Statistique>
                                            <AuthorInfo>
                                                <div>
                                                    <img src={"/images/bg4.jpg"} />
                                                    <span>Alan Jhone</span>
                                                </div>
                                            </AuthorInfo>
                                        </Icons>
                                        <CoursDiscription>
                                            <h6>Cours Discription</h6>
                                            <p>
                                                The interest for Product
                                                Management is expanding at a crazy rate.
                                                An ever-increasing number of organizations are at
                                                last making sense of how significant this control and this job is to their prosperity.<br />
                                                Be that as it may, how precisely do you get into the field? There aren't any degrees
                                                in Product Management and there are no confirmations. Most Product Managers get into
                                                the field through karma or associations. <br /> That closes here - we'll get you modern on ALL
                                                the aptitudes you have to learn Product Management AND have the most obvious opportunity at
                                                landing the position you need.  <br /> There's no greater uncertainty to it. We'll give you what
                                                you have to know and what you need to do - all instructed from a Product Management insider.
                                            </p>
                                            <h6>What you’ll learn</h6>
                                            <p>
                                                Understudies aren't required to know anything already -
                                                we'll show you the essentials, how to apply them, how to
                                                form into a propelled item chief, lastly how to expand your odds
                                                to find a new line of work as a Product Manager.
                                            </p>
                                            <h6>Requirements</h6>
                                            <p>No pre-necessities, in spite of the fact that commonality with fundamental business ideas is useful.</p>
                                            <h6>Course program</h6>
                                            <div>
                                                <Accordion defaultActiveKey="1">
                                                    <Accordion.Item eventKey="1">
                                                        <AcroodinHeader>
                                                            <span>01</span>
                                                            <span>Lession 1</span>
                                                        </AcroodinHeader>
                                                        <Accordion.Body>
                                                            Understudies aren't required to know anything already -
                                                            we'll show you the essentials, how to apply them, how to
                                                            form into a propelled item chief, lastly how to expand your odds
                                                            to find a new line of work as a Product Manager.
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                                <Accordion defaultActiveKey="1">
                                                    <Accordion.Item eventKey="2">
                                                        <AcroodinHeader>
                                                            <span>02</span>
                                                            <span>Lession 2</span>
                                                        </AcroodinHeader>
                                                        <Accordion.Body>
                                                            Understudies aren't required to know anything already -
                                                            we'll show you the essentials, how to apply them, how to
                                                            form into a propelled item chief, lastly how to expand your odds
                                                            to find a new line of work as a Product Manager.
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                                <Accordion defaultActiveKey="1">
                                                    <Accordion.Item eventKey="3">
                                                        <AcroodinHeader>
                                                            <span>03</span>
                                                            <span>Lession 3</span>
                                                        </AcroodinHeader>
                                                        <Accordion.Body>
                                                            Understudies aren't required to know anything already -
                                                            we'll show you the essentials, how to apply them, how to
                                                            form into a propelled item chief, lastly how to expand your odds
                                                            to find a new line of work as a Product Manager.
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                                <Accordion defaultActiveKey="1">
                                                    <Accordion.Item eventKey="4">
                                                        <AcroodinHeader>
                                                            <span>04</span>
                                                            <span>Lession 4</span>
                                                        </AcroodinHeader>
                                                        <Accordion.Body>
                                                            Understudies aren't required to know anything already -
                                                            we'll show you the essentials, how to apply them, how to
                                                            form into a propelled item chief, lastly how to expand your odds
                                                            to find a new line of work as a Product Manager.
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </div>
                                        </CoursDiscription>
                                    </CoursDetails>
                                    <CourseComment />
                                </ScrollAnimation>
                            </Col>
                            <Col lg={4} md={12} sm={12} xs={12}>
                                <ScrollAnimation animateIn="animate__fadeInRight">
                                    <EncrollBtn variant="primary">Encroll to cours</EncrollBtn>
                                    <SinglCourseInfo>
                                        <InfoItem>
                                            <div><i className="fas fa-user"></i> <span>Trainer’s Name</span></div>
                                            <span>ALan Jhone</span>
                                        </InfoItem>
                                        <InfoItem>
                                            <div><i className="far fa-clock"></i> <span>Duration</span></div>
                                            <span>2 Weeks</span>
                                        </InfoItem>
                                        <InfoItem>
                                            <div><i className="fas fa-bell"></i> <span>Lectures</span></div>
                                            <span>10</span>
                                        </InfoItem>
                                        <InfoItem>
                                            <div><i className="fas fa-tags"></i> <span>Branch Name</span></div>
                                            <span>Web Desgin</span>
                                        </InfoItem>
                                        <InfoItem>
                                            <div><i className="fas fa-dollar-sign"></i> <span>Course Fee</span></div>
                                            <span>free</span>
                                        </InfoItem>
                                        <InfoItem>
                                            <div><i className="fas fa-language"></i> <span>Language</span></div>
                                            <span>English, France</span>
                                        </InfoItem>
                                    </SinglCourseInfo>
                                    <TeacherCourse>
                                        <Teacher image="\images\icons8-team-FcLyt7lW5wg-unsplash.jpg" name="Alan Jhone" />
                                    </TeacherCourse>
                                    <MayCard>
                                        <MayCard.Header>Cours Tags</MayCard.Header>
                                        <MayCard.Body>
                                            <Tag text="tag1" />
                                            <Tag text="tag1" />
                                            <Tag text="tag1" />
                                            <Tag text="tag1" />
                                            <Tag text="tag1" />
                                            <Tag text="tag1" />
                                        </MayCard.Body>
                                    </MayCard>
                                </ScrollAnimation>
                            </Col>
                        </Row>
                    </Container>
                </Section>
            </motion.div>
        </>
    )
}
